import { render, staticRenderFns } from "./StudentBillingDetailTable.vue?vue&type=template&id=4a7b02a1&scoped=true&"
import script from "./StudentBillingDetailTable.vue?vue&type=script&lang=js&"
export * from "./StudentBillingDetailTable.vue?vue&type=script&lang=js&"
import style0 from "./StudentBillingDetailTable.vue?vue&type=style&index=0&id=4a7b02a1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a7b02a1",
  null
  
)

export default component.exports